import { tenantOpportunitySettingsService } from '@/services/tenant-opportunity-settings.service';

const initialState = () => ({
  settings: {
    autoCreateFromTenders: false,
    lookbackHours: 48,
  },
  status: {
    error: null,
    pending: false,
    resolved: false,
    rejected: false,
    saving: false,
  },
});

const state = initialState();

const actions = {
  getSettings({ commit }) {
    commit('GET_SETTINGS');
    return tenantOpportunitySettingsService.getSettings().then(
      (settings) => commit('GET_SETTINGS_SUCCESS', settings),
      (error) => {
        commit('GET_SETTINGS_ERROR', error);
        throw error;
      },
    );
  },
  updateSettings({ commit }, settings) {
    commit('UPDATE_SETTINGS');
    return tenantOpportunitySettingsService.updateSettings(settings).then(
      (updated) => commit('UPDATE_SETTINGS_SUCCESS', updated),
      (error) => {
        commit('UPDATE_SETTINGS_ERROR', error);
        throw error;
      },
    );
  },
};

const mutations = {
  GET_SETTINGS(state) {
    state.status = { error: null, pending: true, resolved: false, rejected: false, saving: false };
  },
  GET_SETTINGS_SUCCESS(state, settings) {
    state.status = { ...state.status, pending: false, resolved: true };
    state.settings = settings;
  },
  GET_SETTINGS_ERROR(state, error) {
    state.status = { ...state.status, pending: false, rejected: true, error };
  },
  UPDATE_SETTINGS(state) {
    state.status = { ...state.status, saving: true };
  },
  UPDATE_SETTINGS_SUCCESS(state, settings) {
    state.status = { ...state.status, saving: false };
    state.settings = settings;
  },
  UPDATE_SETTINGS_ERROR(state, error) {
    state.status = { ...state.status, saving: false, error };
  },
};

const getters = {
  settings: (state) => state.settings,
  pending: (state) => state.status.pending,
  saving: (state) => state.status.saving,
  error: (state) => state.status.error,
  resolved: (state) => state.status.resolved,
  rejected: (state) => state.status.rejected,
};

export const tenantOpportunitySettings = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
